import { deriveWorkspaceAccessRequirement, workspaceRoutes } from '#services';
export const needsWorkspaceAuthenticationPredicate = ({ workspaceId, workspaceLoginStatus, }) => {
    const isSuccess = deriveWorkspaceAccessRequirement(workspaceLoginStatus) === null;
    if (isSuccess) {
        return { isSuccess };
    }
    return {
        isSuccess,
        navigateTo: workspaceRoutes.workspaceLock(workspaceId),
    };
};
